<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Ages</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :ages="ages" @edit="editAge"/>
				</div>
			</div>
			<Edit v-if="editOpen" @close="editOpen = false" :age="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import List from '../Age/List.vue'
import Edit from '../Age/Edit.vue'

export default { 
	components: {
		List,
		Edit
	},
	data() {
		return {
			selected: null,
			editOpen: false,
			addOpen: false
		}
	},
	computed : {
		...mapState({
			ages: state => state.age.list
		})
	},
	methods: {
		editAge(age) {
			this.selected = age
			this.editOpen = true
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const ages = this.$store.dispatch('age/getList')

		Promise.all([ages])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Age.vue